<template>
  <div>
    <el-form ref="form" :model="securityForm" :rules="rules" label-width="200px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="报告名称" prop="report_name">
            <el-input v-model="securityForm.report_name" clearable placeholder="请输入报告名称" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检测报告编号" prop="report_number">
            <el-input v-model="securityForm.report_number" clearable placeholder="请输入检测报告编号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="检验日期" prop="inspection_date">
            <el-date-picker
              v-model="securityForm.inspection_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择检验日期"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">设备信息</el-divider>
      </el-col>

      <el-row>
        <el-col :span="8">
          <el-form-item label="设备名称" prop="equipment_name">
            <el-input v-model="securityForm.equipment_name" clearable placeholder="请输入设备名称" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备号牌" prop="equipment_number">
            <el-input v-model="securityForm.equipment_number" clearable placeholder="请输入设备号牌" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="设备型号" prop="equipment_model">
            <el-input v-model="securityForm.equipment_model" clearable placeholder="请输入设备型号" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备颜色" prop="equipment_color">
            <el-input v-model="securityForm.equipment_color" clearable placeholder="请输入设备颜色" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="燃料种类" prop="fuel_type">
            <el-input v-model="securityForm.fuel_type" clearable placeholder="请输入燃料种类" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车架号/VIN" prop="chassis_number">
            <el-input v-model="securityForm.chassis_number" clearable placeholder="请输入车架号/VIN" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="发动机号/电机号" prop="engine_number">
            <el-input v-model="securityForm.engine_number" clearable placeholder="请输入发动机号/电机号" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="出厂日期" prop="manufacture_date">
            <el-date-picker
              v-model="securityForm.manufacture_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择出厂日期"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="16">
          <el-form-item label="制造单位" prop="manufacturing_unit">
            <el-input v-model="securityForm.manufacturing_unit" clearable placeholder="请输入制造单位" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">委托单位信息</el-divider>
      </el-col>

      <el-row>
        <el-col :span="8">
          <el-form-item label="委托单位/委托人" prop="client">
            <el-input v-model="securityForm.client" clearable placeholder="请输入委托单位/委托人" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">检测地点信息</el-divider>
      </el-col>

      <el-row>
        <el-form-item label="检测地点" prop="inspection_location_address">
          <el-col :span="8">
            <el-cascader
              v-model="securityForm.inspection_location"
              size="medium"
              :options="pcTextArr"
              style="width: 100%;"
            />
          </el-col>
          <el-col :span="8">
            <el-input v-model="securityForm.inspection_location_address" style="margin-left: 10px;" clearable placeholder="请输入详细地址" />
          </el-col>
        </el-form-item>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">检测依据</el-divider>
      </el-col>

      <el-row v-for="(standard, index) in securityForm.testing_standards" :key="'standard-' + index">
        <el-col :span="24">
          <el-form-item :label="'检测依据' + (index + 1)" :prop="'testing_standards.' + index">
            <el-input v-model="securityForm.testing_standards[index]" clearable placeholder="请输入检测依据" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">检测仪器设备</el-divider>
      </el-col>

      <el-row v-for="(equipment, index) in securityForm.testing_equipment" :key="'equipment-' + index">
        <el-col :span="6">
          <el-form-item label="仪器名称" :prop="'testing_equipment.' + index + '.name'">
            <el-input v-model="equipment.name" clearable placeholder="仪器名称" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="型号" :prop="'testing_equipment.' + index + '.model'">
            <el-input v-model="equipment.model" clearable placeholder="型号" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="计量有效期" :prop="'testing_equipment.' + index + '.calibration_date'">
            <el-date-picker
              v-model="equipment.calibration_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="计量有效期"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <inspection-items-form v-model="securityForm.inspection_items" />

      <el-col :span="24">
        <el-divider content-position="center">检测结论</el-divider>
      </el-col>

      <el-row>
        <el-col :span="8">
          <el-form-item label="检测结论" prop="inspection_result">
            <el-select v-model="securityForm.inspection_result" placeholder="请选择检测结论">
              <el-option label="合格" value="合格" />
              <el-option label="不合格" value="不合格" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="有效期" prop="validity_period">
            <el-input v-model="securityForm.validity_period" clearable placeholder="请输入有效期" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="报告日期" prop="approval_date">
            <el-date-picker
              v-model="securityForm.approval_date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择报告日期"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-divider content-position="center">设备照片</el-divider>
      </el-col>

      <el-row>
        <el-col :span="24">
          <el-form-item label="外观照片">
            <el-upload
              action=""
              :headers="headers"
              list-type="picture-card"
              :on-success="handleAppearanceSuccess"
              :on-remove="handleAppearanceRemove"
              :file-list="appearanceFileList"
              :before-upload="handleBeforeUpload"
              :http-request="uploadAppearanceFile"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="铭牌照片">
            <el-upload
              action=""
              :headers="headers"
              list-type="picture-card"
              :on-success="handleNameplateSuccess"
              :on-remove="handleNameplateRemove"
              :file-list="nameplateFileList"
              :before-upload="handleBeforeUpload"
              :http-request="uploadNameplateFile"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="text-align: center;">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { pcTextArr } from 'element-china-area-data'
import { detail, update } from '@/api/security'
import { upload } from '@/api/common'
import { getToken } from '@/utils/auth'
import InspectionItemsForm from './InspectionItemsForm.vue'

export default {
  name: 'EditSecurity',
  components: {
    InspectionItemsForm
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pcTextArr,
      appearanceFileList: [],
      nameplateFileList: [],
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      securityForm: {
        id: 0,
        report_name: '',
        report_number: '',
        inspection_date: '',
        equipment_name: '',
        equipment_number: '',
        equipment_model: '',
        equipment_color: '',
        fuel_type: '',
        chassis_number: '',
        engine_number: '',
        manufacture_date: '',
        manufacturing_unit: '',
        client: '',
        inspection_location: [],
        inspection_location_address: '',
        testing_location: '',
        testing_standards: [],
        testing_equipment: [],
        inspection_result: '合格',
        validity_period: '一年',
        approval_date: '',
        vehicle_photo: [],
        nameplate_photo: [],
        inspection_items: {
          vehicle_identification: {
            items: [
              { code: '1.1', requirement: '车辆应具有出厂合格证书及有关技术资料', result: '' },
              { code: '1.2', requirement: '车辆易见部位上应有产品的商标或厂标', result: '' },
              { code: '1.3', requirement: '车辆应在产品标牌上标明产品名称、型号、制造日期或产品编号、制造商名称及制造国', result: '' },
              { code: '1.4', requirement: '车辆的发动机、底盘易见部位应具有永久清晰字样的编号', result: '' }
            ],
            judgment: ''
          },
          cab_inspection: {
            items: [
              { code: '2.1', requirement: '装有封闭式驾驶室的车辆，驾驶室应装有门锁，且完好有效', result: '' },
              { code: '2.2', requirement: '封闭式驾驶室内应通风良好，装设的取暖、风挡除霜和遮阳装置应完好有效', result: '' },
              { code: '2.3', requirement: '驾驶员座椅应保证其舒适、牢靠，前后可调整', result: '' },
              { code: '2.4', requirement: '驾驶室应保持视线良好，视野开阔', result: '' },
              { code: '2.5', requirement: '前风挡玻璃应采用符合 GB 9656 规定的安全玻璃', result: '' },
              { code: '2.6', requirement: '前风挡玻璃装置的刮水器应完好有效，应确保驾驶员有良好的前方视野', result: '' },
              { code: '2.7', requirement: '配有灭火器的车辆，应保证其灭火器在有效期内，且功能有效', result: '' }
            ],
            judgment: ''
          },
          engine_inspection: {
            items: [
              { code: '3.1', requirement: '发动机应能正常启动、熄火，运转平稳，怠速稳定，机油压力正常', result: '' },
              { code: '3.2', requirement: '发动机的安装应牢固可靠，连接部分无松动、脱落、损坏', result: '' },
              { code: '3.3', requirement: '点火系统、燃料系统、润滑系统、冷却系统的机件应齐全，性能良好，安装牢固，线路无漏电现象，管路无渗漏', result: '' }
            ],
            judgment: ''
          },
          transmission_inspection: {
            items: [
              { code: '4.1', requirement: '离合器分离彻底，结合平稳，不打滑、无异响', result: '' },
              { code: '4.2', requirement: '离合器踏板的自由行程应符合该车整车技术条件的规定', result: '' },
              { code: '4.3', requirement: '离合器踏板分离时，踏板力不应大于 300 N，手握力不应大于 200 N', result: '' },
              { code: '4.4', requirement: '变速器变速杆的位置适当，自锁、互锁可靠，不应有乱档和自动跳档现象；变速器、分动器应不漏无异响', result: '' },
              { code: '4.5', requirement: '万向节、传动轴、中间轴承、传动链条应运转平稳，螺栓齐全，紧固牢靠，运行中不应发生振抖和异响', result: '' },
              { code: '4.6', requirement: '驱动桥壳、桥管不允许有变形和裂纹，驱动桥工作应正常且不应有异响；半轴螺栓齐全紧固', result: '' },
              { code: '4.7', requirement: '油门踏板释放后，应保证其能自动复位', result: '' }
            ],
            judgment: ''
          },
          driving_system_inspection: {
            items: [
              { code: '5.1', requirement: '车架无变形、裂纹、锈蚀，螺栓铆钉无缺损松动', result: '' },
              { code: '5.2', requirement: '钢板弹簧、卡子、螺栓紧固，与桥及车架连接紧固', result: '' },
              { code: '5.3', requirement: '前后桥无变形和裂纹', result: '' },
              { code: '5.4', requirement: '同一车桥装用同一型号轮胎', result: '' },
              { code: '5.5', requirement: '充气轮胎气压和负荷不大于规定值', result: '' },
              { code: '5.6', requirement: '充气轮胎磨损花纹深度≥3.2mm，胎面/胎壁无超过25mm的长裂纹或露出帘布层', result: '' },
              { code: '5.7', requirement: '轮辋完好，螺栓螺母齐全紧固', result: '' },
              { code: '5.8', requirement: '履带部件完整、运转正常、无裂纹变形', result: '' },
              { code: '5.9', requirement: '履带每10节直线度误差≤4mm，全长误差≤8mm', result: '' }
            ],
            judgment: ''
          },
          instrument_inspection: {
            items: [
              { code: '6.1', requirement: '各种仪表（气压、机油压、水温、燃油量、电压等）设置齐全、灵敏、有效', result: '' }
            ],
            judgment: ''
          },
          electrical_inspection: {
            items: [
              { code: '7.1', requirement: '喇叭声级在 90 dB (A) ~ 115 dB (A) 范围内', result: '' },
              { code: '7.2', requirement: '电器导线布置合理、固定、接头牢固、绝缘套完好', result: '' },
              { code: '7.3', requirement: '蓄电池极柱连接牢固可靠、无锈蚀、涂抹防锈脂', result: '' },
              { code: '7.4', requirement: '电解液面高出极板 10mm~15mm，加液孔盖齐全、通气孔畅通', result: '' },
              { code: '7.5', requirement: '蓄电池金属盖板与带电部分间隙>30mm；若有绝缘层则间隙≥10mm', result: '' },
              { code: '7.6', requirement: '电动机运转平稳无异响、温升正常、防护罩齐全', result: '' },
              { code: '7.7', requirement: '电动机悬挂及各处连接牢固可靠', result: '' },
              { code: '7.8', requirement: '蓄电池车的紧急断电装置为机械式且易于操作', result: '' },
              { code: '7.9', requirement: '换向开关、制动联锁、零位保护、过电流保护装置有效', result: '' }
            ],
            judgment: ''
          },
          hydraulic_system_inspection: {
            items: [
              { code: '8.1', requirement: '管路布置不与运动部件干涉', result: '' },
              { code: '8.2', requirement: '密封性能良好，作业时无渗油，运动接口无漏油', result: '' },
              { code: '8.3', requirement: '在空载和满载情况下，液压元件均能正常工作', result: '' },
              { code: '8.4', requirement: '设置滤油器和防尘装置，加油口有滤网', result: '' }
            ],
            judgment: ''
          }
        }
      },
      rules: {
        report_number: [
          { required: true, message: '请输入检测报告编号', trigger: 'blur' }
        ],
        inspection_date: [
          { required: true, message: '请选择检验日期', trigger: 'change' }
        ],
        equipment_name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        client: [
          { required: true, message: '请输入委托单位/委托人', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    'item.id': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.loadData()
        }
      },
      immediate: false
    }
  },
  methods: {
    loadData() {
      detail(this.item.id).then(response => {
        const data = response.data
        this.securityForm.id = data.id
        this.securityForm.report_name = data.report_name || ''
        this.securityForm.report_number = data.report_number
        this.securityForm.inspection_date = data.inspection_date
        this.securityForm.equipment_name = data.equipment_name
        this.securityForm.equipment_number = data.equipment_number
        this.securityForm.equipment_model = data.equipment_model
        this.securityForm.equipment_color = data.equipment_color
        this.securityForm.fuel_type = data.fuel_type
        this.securityForm.chassis_number = data.chassis_number
        this.securityForm.engine_number = data.engine_number
        this.securityForm.manufacture_date = data.manufacture_date
        this.securityForm.manufacturing_unit = data.manufacturing_unit
        this.securityForm.client = data.client
        this.securityForm.inspection_location = data.inspection_location || []
        this.securityForm.inspection_location_address = data.inspection_location_address
        
        // 处理照片列表
        const baseUrl = process.env.VUE_APP_BASE_URL
        this.appearanceFileList = (data.vehicle_photo || []).map(url => ({
          url: url.startsWith('http') ? url : baseUrl + '/' + url,
          name: '外观照片'
        }))
        this.nameplateFileList = (data.nameplate_photo || []).map(url => ({
          url: url.startsWith('http') ? url : baseUrl + '/' + url,
          name: '铭牌照片'
        }))
        this.securityForm.vehicle_photo = data.vehicle_photo || []
        this.securityForm.nameplate_photo = data.nameplate_photo || []
        this.securityForm.testing_location = data.testing_location
        this.securityForm.testing_standards = data.testing_standards || []
        this.securityForm.testing_equipment = data.testing_equipment || []
        this.securityForm.inspection_result = data.inspection_result || '合格'
        this.securityForm.validity_period = data.validity_period || '一年'
        this.securityForm.approval_date = data.approval_date

        if (data.inspection_items) {
          this.securityForm.inspection_items = data.inspection_items
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          try {
            const response = await update(this.securityForm)
            if (response.code === 0) {
              this.$message.success('更新成功')
              this.$emit('success')
            } else {
              this.$message.error(response.message || '更新失败')
            }
          } catch (error) {
            this.$message.error('更新失败')
          }
        }
      })
    },
    handleReset() {
      this.loadData()
    },
    handleBeforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isGIF = file.type === 'image/gif'
      const isBMP = file.type === 'image/bmp'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!(isJPG || isPNG || isGIF || isBMP)) {
        this.$message.error('上传图片只能是 JPG/PNG/GIF/BMP 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return (isJPG || isPNG || isGIF || isBMP) && isLt5M
    },
    handleAppearanceSuccess(response) {
      this.securityForm.vehicle_photo.push(response.data.path)
    },
    handleAppearanceRemove(file) {
      this.securityForm.vehicle_photo.splice(this.securityForm.vehicle_photo.indexOf(file.url), 1)
    },
    handleNameplateSuccess(response) {
      this.securityForm.nameplate_photo.push(response.data.path)
    },
    handleNameplateRemove(file) {
      this.securityForm.nameplate_photo.splice(this.securityForm.nameplate_photo.indexOf(file.url), 1)
    },
    uploadAppearanceFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      return upload(formData)
    },
    uploadNameplateFile(params) {
      const formData = new FormData()
      formData.append('file', params.file)
      return upload(formData)
    }
  }
}
</script>

<style scoped>
.el-divider {
  margin: 20px 0;
}
</style>
